import { createReducer } from '@reduxjs/toolkit';
import { StoreAppState } from '../types/StoreState';
import { checkApCanMakePayments } from '../actions/checkApCanMakePayments';
import { checkApHighestSupportedVersion } from '../actions/checkApHighestSupportedVersion';
import { checkPayPalMethodsEligibility } from '../actions/checkPayPalMethodsEligibility';
import { loadExperiments } from '../actions/loadExperiments';
import { setSessionId } from '../actions/setSessionId';

// @ts-expect-error
const initialState: StoreAppState = {};

export const appStateReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(checkPayPalMethodsEligibility, (state, action) => {
      state.payPalMethodsEligibility = action.payload;
    })
    .addCase(checkApCanMakePayments.fulfilled, (state, action) => {
      state.applePayCanMakePayments = action.payload;
    })
    .addCase(checkApCanMakePayments.rejected, (state, action) => {
      state.applePayCanMakePayments = action.payload;
    })
    .addCase(checkApHighestSupportedVersion.fulfilled, (state, action) => {
      state.highestSupportedApplePayVersion = action.payload;
    })
    .addCase(checkApHighestSupportedVersion.rejected, (state, action) => {
      state.highestSupportedApplePayVersion = action.payload;
    })
    .addCase(loadExperiments, (state, action) => {
      state.experiments = action.payload;
    })
    .addCase(setSessionId, (state, action) => {
      state.sessionId = action.payload;
    });
});
